import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-home",
  "use": "icon-sidebar-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sidebar-home\">\n    <path d=\"M944.25 422.24l-390-342.83a64 64 0 0 0-84.5 0l-390 342.83c-22.17 19.47-8.38 56 21.13 56H160V832a64 64 0 0 0 64 64h172.8V672a64 64 0 0 1 64-64h102.4a64 64 0 0 1 64 64v224H800a64 64 0 0 0 64-64V478.27h59.12c29.51 0 43.29-36.56 21.13-56.03z\" p-id=\"11013\" fill=\"#ffffff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol